import {AfterContentInit, Component, OnDestroy, OnInit, ViewContainerRef} from '@angular/core';
import {Title} from '@angular/platform-browser';
import {GLOBAL} from './shared/global';
import {AuthGuard} from './auth/auth.guard';
import {SpinnerService} from './spinner/spinner.service';
import {VerifiedGuard} from './auth/verified.guard';
import {Router} from '@angular/router';
import {fromEvent} from 'rxjs/observable/fromEvent';
import {distinctUntilChanged, filter, tap, delay} from 'rxjs/operators';
import {merge} from 'rxjs/observable/merge';
import { MdDialog, MdDialogConfig } from '@angular/material';
import { PopupComponent } from './shared/popup/popup.component';
import { PopupService } from './shared/popup/popup.service';

declare var $: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit, OnDestroy {
  public isRequesting = false;
  private sub: any;

  public constructor(
    public spinnerService: SpinnerService,
    public titleService: Title,
    private router: Router,
    public dialog: MdDialog,
    private popupService: PopupService) {
    this.titleService.setTitle(GLOBAL.TITLE + GLOBAL.VERSION);
    this.sub = this.spinnerService.requestInProcess$.subscribe((isDone) => {
      this.isRequesting = isDone;
    });

    this.popupService.showPopup$.subscribe((showPopup) => {
      if (showPopup) {
        this.openDialog();
      }
    });
  }

  openDialog() {
    const dialogRef = this.dialog.open(PopupComponent, {
      data: this.popupService.data
    });
    dialogRef.afterClosed().subscribe((res) => {
      res ? this.popupService.onConfirm() : this.popupService.onCancel();
    });
  }

  isLoggedIn() {
    return AuthGuard.isLoggedIn() && GLOBAL.currentUser.verified === true && GLOBAL.currentUser.disabled === false;
  }

  showProgress(val: boolean) {
    this.isRequesting = val;
  }

  ngOnInit() {
    /* Auto login/logout from external tab functionality */
    const tokenUpdateExternally$ = fromEvent(window, 'storage', true).pipe(
      filter((event: StorageEvent) => event.key === 'token' && document.hasFocus())
    );

    const login$ = tokenUpdateExternally$.pipe(
      filter((event: StorageEvent) => !!event.newValue),
      filter(() => !AuthGuard.isTokenInvalid() && this.router.url.startsWith('/authenticate')),
      delay(3000),
      tap(() => (window.location.href = '/'))
    );
    const logout$ = tokenUpdateExternally$.pipe(
      filter((event: StorageEvent) => !event.newValue),
      filter(() => !AuthGuard.isLoggedIn() && !this.router.url.startsWith('/authenticate')),
      tap(() => (window.location.href = '/'))
    );

    merge(login$, logout$).subscribe();
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts